import { filter } from 'rxjs/operators';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import 'slick-carousel';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesTable } from '@toro/common/shared/resources/routes-table.model';
import { Subscription, Observable } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { FinanceState } from '@toro/common/shared/state-management/finance/finance.reducer';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { Roles } from '@toro/common/shared/models/roles/roles.enum';
import { UserProfileState } from '@toro/common/shared/state-management/userprofile/userprofile.reducer';
import { UsersAction } from '@toro/common/shared/state-management/users/users.actions';
import { LoginWraperService } from '@toro/common/shared/services/login.wraper.service';

import {
  trigger,
  transition,
  animate,
  style,
  state,
} from '@angular/animations';
import { formatCBLC } from './../../shared/utils';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import {
  UserNotifierActionType,
  UserNotifierProductType,
  UserNotifierService,
} from '@hub-workspace/apps/logged-home/src/app/shared/services/user/user-actions-notifier.service';

@AutoUnsubscribe()
@Component({
  selector: 'transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.scss'],
  animations: [
    trigger('fadeInOutAnim', [
      state('initial', style({ opacity: '0' })),
      state('final', style({ opacity: '1' })),
      transition('initial=>final', animate('0.5s ease-in-out')),
      transition('final=>initial', animate('0.5s ease-in-out')),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class TransferComponent implements OnInit {
  public showInfosMobile: boolean;
  public textBtInfosMobile: string;
  public openYoutubeDialog = false;

  public finance$: Observable<FinanceState>;
  public auth$: Observable<UsersState>;
  public user$: Observable<UserProfileState>;
  public isIdentified: boolean = null;
  public isLogged: boolean = null;
  public isRegistered: boolean = null;
  public consolidatedPositionSubscription: Subscription;
  public consolidatedPosition: any;
  public userAuth: any;
  public user: any;
  public staticCpfCnpj: any;
  public cpfCnpjNameCamp: string;
  public cblcArray: { name: string; code: number; cblcType: number }[];
  public token: string;
  public isStaticCpfCnpj: boolean;

  public bankAnimState = { state: 'initial' };
  public agencyAnimState = { state: 'initial' };
  public accountAnimState = { state: 'initial' };
  public cpfAnimState = { state: 'initial' };
  public balance = 0;
  public transferCategory: string;
  private currentUser: any;

  private limitIncreased: boolean = false;

  constructor(
    public utilitiesService: UtilitiesService,
    private userNotifierService: UserNotifierService,
    private store: Store<AppState>,
    private router: Router,
    private loginWraperService: LoginWraperService,
    private route: ActivatedRoute
  ) {
    this.consolidatedPositionSubscription = this.store
      .select((s) => s.finance.consolidatePosition)
      .subscribe((position) => {
        this.consolidatedPosition = position;
        this.updateBalance();
      });

    this.auth$ = this.store.select((s) => s.authentication);
    this.finance$ = this.store.select((s) => s.finance);
    this.user$ = this.store.select((s) => s.userProfile);

    this.auth$.pipe(filter((data) => !!data.currentUser)).subscribe((data) => {
      this.token = data.currentUser.token;
      this.isLogged = data.currentUser ? true : false;
      this.isIdentified = this.isLogged
        ? data.currentUser.role === Roles.Identified
        : null;
      this.isRegistered = data.currentUser.role === Roles.Registered;
      if (data.currentUser === null) return;
      this.userAuth = { ...data };
      this.currentUser = { ...data.currentUser };

      this.userAuth.currentUser = {
        ...this.userAuth.currentUser,
        cblc: formatCBLC(this.userAuth.currentUser.cblc),
      };
    });

    this.user$.subscribe((user) => (this.user = user));

    // Guard evita TypeError no constructor quando userAuth ainda nao foi resolvido (subscribe assincrono).
    if (this.userAuth && this.userAuth.currentUser && this.userAuth.currentUser.cblc) {
      this.userNotifierService
        .sendUserNotifierIntention({
          cblc: this.userAuth.currentUser.cblc,
          productType: UserNotifierProductType.DadosBancarios,
          userActionType: UserNotifierActionType.Visualization,
          dateOperation: new Date().getTime(),
        })
        .subscribe();
    }

    this.route.queryParams
      .pipe(filter((params) => params.category))
      .subscribe((params) => {
        this.transferCategory = params.category;
      });
  }

  public ngOnInit() {
    window.scrollTo(0, 0);
    this.showInfosMobile = false;
    this.textBtInfosMobile = 'Ver mais';
    this.store.dispatch({ type: UsersAction.getUserCblc });
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: 'Loaded a Page',
        events: {
          action: ActionEventsEnum.VIEW,
          platform: 'Hub Logged Home - Transferência',
        },
      },
    });

    this.store
      .select(({ authentication }) => authentication)
      .subscribe(({ cblcArray }) => {
        if (cblcArray.length > 0) this.checkCblcType(cblcArray);
      });
  }

  public updateBalance() {
    if (!this.consolidatedPosition) {
      return;
    }

    if (this.limitIncreased) {
      this.balance = this.consolidatedPosition.totalOperationGuarantee;
    }
    this.balance = this.consolidatedPosition.accountBalance;
  }

  /**
   * Abre o painel de login
   */
  public showLoginPanel() {
    const snapshot = this.router.routerState.snapshot.url;
    this.loginWraperService.navigateToLogin({
      afterLoginRedirectTo: snapshot,
    });
  }

  /**
   * Mostra o card de TED correto de acordo com o status de login do usuário
   */
  public showUserAccount() {
    if (!this.user || !this.userAuth) return false;

    return this.user.user.cpfcnpj && this.userAuth.currentUser.cblc;
  }

  /**
   * Redireciona o usuário para as contas bancárias em "Minha Conta"
   */
  public redirectToBankData() {
    this.router.navigateByUrl(RoutesTable.hubUrls.routes.MyAccountBankData.uri);
  }

  public scrollInterationClickButtom() {
    const body = $('html, body');
    const scrollTopElement = $('#doubts-section').offset().top;

    body.animate({ scrollTop: scrollTopElement }, 700);
  }

  public openYoutubeDialogReceiver(value) {
    this.openYoutubeDialog = value;
  }

  public closeYoutubeDialogReceiver(value) {
    this.openYoutubeDialog = value;
  }

  public openYoutube() {
    this.openYoutubeDialog = true;
  }

  /**
   * Copia a agência para a área de transferência do usuário
   */
  public copyBank() {
    this.animateCopy(this.bankAnimState);
    this.copyToClipboard('352');
  }

  /**
   * Copia a agência para a área de transferência do usuário
   */
  public copyAgency() {
    this.animateCopy(this.agencyAnimState);
    this.copyToClipboard('0001');
  }

  /**
   * Copia a conta (CBLC) sem dígito para a área de transferência do usuário
   */
  public copyAccount() {
    this.animateCopy(this.accountAnimState);
    this.copyToClipboard(this.currentUser.cblc);
  }

  /**
   * Copia o CPF (somente números) para a área de transferência do usuário
   */
  public copyCPF() {
    this.animateCopy(this.cpfAnimState);
    this.copyToClipboard(this.user.user.cpfcnpj);
  }

  /**
   * Faz o trigger da animação /// Obs.: Se for precisar em outros componentes, criar diretiva generalizada
   * @param animState variavel de estado da animação de cada componente
   */
  private animateCopy(animState) {
    animState.state = 'final';
    setTimeout(() => {
      animState.state = 'initial';
    }, 2000);
  }

  public checkCblcType(data: any) {
    const cblcType = data.find(
      (e) => formatCBLC(e.code) === this.userAuth.currentUser.cblc
    );

    const PersonType = this.utilitiesService.extractJwtKeyValue(
      this.token,
      'PersonType'
    );

    const INDIVIDUAL_CUSTOMER = PersonType == 'IndividualCustomer';

    const CORPORATE_CUSTOMER = PersonType == 'CorporateCustomer';

    const UNDEFINED_CBLC = cblcType.cblcType == undefined;

    const OWN_CBLC = cblcType.cblcType == 0;

    const ADMINISTRATOR_CBLC = cblcType.cblcType == 1;

    const EMITTER_CBLC = cblcType.cblcType == 2;

    const ATTORNEY_CBLC = cblcType.cblcType == 3;

    if ((OWN_CBLC && INDIVIDUAL_CUSTOMER) || UNDEFINED_CBLC) {
      this.cpfCnpjNameCamp = 'CPF: ';
    }

    if (CORPORATE_CUSTOMER) {
      this.cpfCnpjNameCamp = 'CNPJ: ';
    }

    if (ADMINISTRATOR_CBLC || EMITTER_CBLC) {
      this.cpfCnpjNameCamp = 'CNPJ:';
      this.staticCpfCnpj = 'CNPJ da Conta';
    }

    if (ATTORNEY_CBLC) {
      this.cpfCnpjNameCamp = 'CPF: ';
      this.staticCpfCnpj = 'CPF da Conta';
    }
  }

  /**
   * Verifica se o CPF e CNPJ do Cliente está aparecendo de forma estática na tela de transferencia
   */
  public checkStaticCpfCnpj() {
    if (this.staticCpfCnpj) return true;
  }

  /**
   * Helper para copiar um texto para a área de transferência do usuário
   * @param {string} item a ser copiado para a área de transferência
   */
  private copyToClipboard(item) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }
}
